module.exports = __webpack_public_path__ + "img/odisha_2.f006f96a.png";